import
{OnDestroy, Input, TemplateRef, Directive, ViewRef, ViewContainerRef, OnInit} from "@angular/core";
import {LogManager} from "../../log/services/log.manager";
import {LogCat} from "../../log/services/log.manager.categories";

/**
 * structural directive used to remove templates from the DOM for optimizations.
 * it should be used with care only when needed and may require change detection activation
 * and returning to dom before running the on destroy of inner components.
 * use with care. (see session wrapper for example)
 */
@Directive({
	selector:'[cpOnDom]',
})
export class ShowOnDOMWhenActiveDirective implements OnInit, OnDestroy{
	public offlinedViewRef : ViewRef;

	constructor(private templateRef: TemplateRef<any>,private viewContainerRef: ViewContainerRef){}

	public ngOnDestroy(){
		if (this.offlinedViewRef && !this.offlinedViewRef.destroyed){
			LogManager.debug(LogCat.AppShell.Sessions,"about to initiate destroy of offline view");
			this.offlinedViewRef.destroy();
		}
	}

	public ngOnInit(){
		this.viewContainerRef.createEmbeddedView(this.templateRef);
	}

	@Input() set cpOnDom(putOnDOM:boolean){
		if (putOnDOM && !this.offlinedViewRef){
			LogManager.debug(LogCat.AppShell.Sessions,"requested to put on dom, but already there");
		}else if (!putOnDOM && this.offlinedViewRef){
			LogManager.warn(LogCat.AppShell.Sessions,"requested to remove from dom, but already not there");
		}else if (putOnDOM){
			LogManager.debug(LogCat.AppShell.Sessions,"requested to add to dom");
			this.viewContainerRef.insert(this.offlinedViewRef);
			this.offlinedViewRef = null;
		}else{
			LogManager.debug(LogCat.AppShell.Sessions,"requested to remove from dom");
			this.offlinedViewRef=this.viewContainerRef.detach();
		}
	}
}
